import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Button from '@starbucks-web/pattern-library/lib/components/button';

const CantAccessEmailUrl = ({ cantAccessEmailUrl }) => (
  <Button
    className="mxn3 text-left"
    href={cantAccessEmailUrl}
    visualStyle="textOnly"
  >
    <FormattedMessage
      defaultMessage="Can’t access email?"
      description="Hint text with link for users who can’t access their email"
      id="accountSignin.cantAccessEmail.message"
    />
  </Button>
);

CantAccessEmailUrl.displayName = 'CantAccessEmailUrl';

CantAccessEmailUrl.propTypes = {
  cantAccessEmailUrl: PropTypes.string.isRequired,
};

const select = (state) => ({
  cantAccessEmailUrl: state.config.cantAccessEmailUrl,
});

export default connect(select)(CantAccessEmailUrl);
